import React from 'react'

const Customers = () => {
  return (
    <div>Customers Page</div>
  )
}

export default Customers;